<template>
  <vs-popup
    class="popup-historico-baixas"
    :title="'Histórico de Baixas'"
    :active.sync="popupHistoricoBaixas"
    @close="popupHistoricoBaixas = false"
  >
    <div v-if="!carregando">
      <table>
        <tr>
          <th class="uppercase">Nosso Número:</th>
          <td>{{ dadosHistoricoBaixas.nossoNumero }}</td>
        </tr>
      </table>

      <hr class="my-2" />

      <h5 class="my-2">Baixas</h5>

      <table class="table" v-for="(item, index) in dados" :key="index">
        <tr>
          <th class="uppercase text-right">#{{ index + 1 }}</th>
        </tr>

        <tr>
          <th class="uppercase text-right">Data:</th>
          <td class="text-left">{{ formataData(item.data_ocorrencia) }}</td>
        </tr>

        <!-- <tr>
          <th class="uppercase text-right">Hora:</th>
          <td class="text-left">{{ formataHora(item.data_ocorrencia) }}</td>
        </tr> -->

        <tr>
          <th class="uppercase text-right">Valor do Boleto:</th>
          <td class="text-left">{{ item.valor_boleto | currency }}</td>
        </tr>

        <tr>
          <th class="uppercase text-right">Valor do Pagamento:</th>
          <td class="text-left">{{ item.valor_pagamento | currency }}</td>
        </tr>

        <tr>
          <th class="uppercase text-right">Baixado por:</th>
          <td class="text-left">{{ item.baixadoPor }}</td>
        </tr>

        <tr v-if="dados.length > index + 1">
          <td colspan="2">
            <hr class="hr-table my-2" />
          </td>
        </tr>
      </table>
    </div>
  </vs-popup>
</template>

<script>
import service from '../../services';
import moment from 'moment';
import utils from '../../utils/dateConversion';

export default {
  name: 'ModalBoletosExcluidos',

  props: ['dadosHistoricoBaixas'],

  data() {
    return {
      carregando: true,
      popupHistoricoBaixas: false,
      dados: [],
    };
  },

  watch: {
    dadosHistoricoBaixas() {
      this.preencheModal();
    },
  },

  methods: {
    preencheModal() {
      this.carregando = true;
      this.$vs.loading();
      this.dados = [];
      this.popupHistoricoBaixas = true;

      service
        .post('Boletos', 'buscar-historico-baixas', {
          idBoleto: this.dadosHistoricoBaixas.idBoleto,
        })
        .then(({ data }) => {
          this.dados = data;

          this.$vs.loading.close();
          this.carregando = false;
        })
        .catch((erro) => {
          console.log(erro);
        });
    },

    formataData(data) {
      const [_data, _] = utils.convertISOToDateHour(data).split(' ');
      return _data;
    },

    formataHora(data) {
      const [_, _hora] = utils.convertISOToDateHour(data).split(' ');
      return _hora;
    },
  },
};
</script>

<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 2px;
  }

  tr:nth-child(2n) {
    background: #efefef;
  }
}

.hr-table {
  color: rgb(209, 209, 209);
}
</style>

<style>
.popup-historico-baixas.con-vs-popup .vs-popup {
  width: fit-content !important;
}
</style>
